import IFactSheetProperty from './IFactSheetProperty';

export default interface IWorkFile extends Array<IFactSheetProperty> {}

/**
 * Generates an empty instance of IWorkFile
 * @returns
 */
export function newWorkFile(): IWorkFile {
    const result: IWorkFile = [];
    return result;
}
